class AppController {
  constructor(
    $rootScope,
    $timeout,
    $http,
    emittentenService,
    $window,
    $location
  ) {
    'ngInject';
    this.name = 'app';
    this.$rootScope = $rootScope;
    this.page = $rootScope.page;
    this.$window = $window;
    this.$location = $location;

    this.params = this.getUrlParams(window.location.href);

    /**
     * Function to be called if the current page has a transition
     * @param  {string} $routeChangeStart     the event
     * @param  {object} event                 the event object
     * @return {void}
     */
    $rootScope.$on('$locationChangeSuccess', (event, data) => {
      if ($rootScope.editable) {
        var el = jQuery(
          '<div ng-class="{\'background-editable\': $root.editable}" class="background" id="newBackground" style="background-image: url(/app/assets/images/backgrounds/bg' +
            this.randomIntFromInterval(1, 8) +
            '.jpg)"></div>'
        );
      } else {
        var el = jQuery(
          '<div class="background" id="newBackground" style="background-image: url(/app/assets/images/backgrounds/bg' +
            this.randomIntFromInterval(1, 7) +
            '.jpg)"></div>'
        );
      }
      jQuery('#currentBackground')
        .before(el)
        .css('opacity', '0');
      $timeout(() => {
        jQuery('#currentBackground').remove();
        el.attr('id', 'currentBackground');
      }, 1000);
    });

    emittentenService.getCurrentEventId();

    var currentUser = this.$window.localStorage.getItem('currentUser');
    if (!currentUser) {
      if (this.params.token) currentUser = JSON.stringify(this.params);

      //var path = this.$location.$path;
      //var newUrl = this.removeURLParameter(window.location.href, 'token');
      //history.replaceState('data to be passed', '', newUrl);
    }
    if (currentUser) currentUser = JSON.parse(currentUser);
    if (currentUser && currentUser.token) {
      this.$rootScope.config.tokenHeader = {
        'x-access-token': currentUser.token,
      };
    }
  }

  randomIntFromInterval(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
  }

  getUrlParams(url) {
    var params = {};
    (url + '?')
      .split('?')[1]
      .split('&')
      .forEach(function(pair) {
        pair = (pair + '=').split('=').map(decodeURIComponent);
        if (pair[0].length) {
          params[pair[0]] = pair[1];
        }
      });
    return params;
  }

  removeURLParameter(url, parameter) {
    //prefer to use l.search if you have a location/link object
    var urlparts = url.split('?');
    if (urlparts.length >= 2) {
      var prefix = encodeURIComponent(parameter) + '=';
      var pars = urlparts[1].split(/[&;]/g);

      //reverse iteration as may be destructive
      for (var i = pars.length; i-- > 0; ) {
        //idiom for string.startsWith
        if (pars[i].lastIndexOf(prefix, 0) !== -1) {
          pars.splice(i, 1);
        }
      }

      url = urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
      return url;
    } else {
      return url;
    }
  }
}

export default AppController;



// WEBPACK FOOTER //
// ./client/app/app.controller.js